import React from "react";
import PropTypes from "prop-types";
import { isButtonDisabled } from "../../services/megamixUtils";
import { Button } from "react-onsenui";

const style = {
  button: {
    width: 100,
    height: 80,
    position: "relative",
    padding: 0,
    backgroundColor: "transparent",
    display: "grid",
  },
  markerContainer: {
    width: 40,
    height: 40,
    borderRadius: 30,
    justifySelf: "center",
    boxShadow: "0px 2px 10px rgb(0 0 0 / 20%)",
    marginTop: 10,
//    WebkitMaskImage: "linear-gradient(0deg, rgb(0 0 0) 0%, rgb(0 0 0) 35%, rgb(255 255 255 / 40%) 100%)",
//    background: "radial-gradient(circle at 17px 17px, #ffffff5e, #0000)",
    transition: "transform 0.2s", // Add transition for enlargement
  },
  nameContainer: {
    backgroundColor: "#fff",
    position: "absolute",
    bottom: 0,
    width: "65%",
    textTransform: "uppercase",
    // borderTop: "1px solid #ccc",
    lineHeight: "20px",
    boxShadow: "1px 1px 4px rgb(0 0 0 / 10%), -1px 1px 4px rgb(0 0 0 / 10%)",
    marginBottom: "15px",
    marginTop: "-10px",
    borderRadius: "3px",
    marginLeft: "17%",
  },
};

export default class ColorButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false
    };
  }

  onButtonPress() {
    const { onColorButtonPress } = this.props;
    onColorButtonPress();
  }

  updateButtonDisabled() {
    const { colorId, query, queries, currentSubstanceIds } = this.props;
    const disabled = isButtonDisabled(colorId, query, queries, currentSubstanceIds);
    this.setState({disabled: disabled});
  }

  componentWillReceiveProps(nextProps) {
    setTimeout(() => this.updateButtonDisabled(), Math.floor(Math.random() * 50));
  }

  render() {
    const { disabled } = this.state;
    const { hex, colorName, label, isSelected, colorId } = this.props;
    const buttonStyleOverride = this.props.buttonStyle || {};

    const hexGradient = hex + " linear-gradient(180deg, #fff -85%, #0000 95%)";
    const colorLabel = label.slice(0, -1);

    const buttonOpacity = disabled === true ? "0.25" : "1";
    const buttonCursor = disabled === true ? null : "pointer";
    const buttonStyle = {
      ...style.button,
      gridArea: colorName,
      opacity: buttonOpacity,
      cursor: buttonCursor,
      ...buttonStyleOverride,
    };
    const bulbStyle = {
      ...style.markerContainer,
      background: hexGradient,
      transform: isSelected ? "scale(1.35)" : "scale(1)", // Enlarge by 35% when selected
    };
    const colorContainerStyle = {
      ...style.nameContainer,
      background: isSelected ? hexGradient : "white",
      position: 'relative', // Needed to position the pseudo-element
    };
  
    const textStyle = {
      backgroundClip: 'text',
      color: isSelected ? "white" : hex,
      fontSize: '12px',
      textTransform: 'uppercase', // Make the text uppercase
      display: 'inline', // Use inline to fit the size of the text
    };
  
    return (
      <Button
        className="colorButton"
        style={buttonStyle}
        onClick={() => this.onButtonPress()}
      >
        <div className="colorBulb" style={bulbStyle}></div>
        <div className="colorLabel" style={colorContainerStyle}>
          <span style={textStyle}>{colorLabel}</span>
        </div>
      </Button>
    );
  }
}

ColorButton.propTypes = {
  hex: PropTypes.string.isRequired,
  onColorButtonPress: PropTypes.func.isRequired,
  colorName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  buttonStyle: PropTypes.object,
};
